<template>
  <div>
    <div class="row">
      <div class="col-12 bread-crumbs">
        <router-link to="/events/">События</router-link>/
        <router-link :to="'/events/edit/'+$route.params.eventId">{{event.title}}</router-link>
      </div>
    </div>
    <h1>Управление постами</h1>
    <div class="post-cards-wrap">
      <div
        class="empty-card"
        @click="$router.push({path:'/events/'+$route.params.eventId+'/posts/add/'})">

        <SvgIcon name="big_cross" width="80" height="80"></SvgIcon>
        <div>Новый пост</div>
      </div>
      <div v-for="post in Posts.posts" :key="post.id">
        <div class="post-card" @click="$router.push({path:'/events/'+$route.params.eventId+'/posts/edit/'+post.id})">
            <div class="picture_control">
                <div class="remove-pic" @click="confirmModal($route.params.eventId, post.id)" @click.stop>
                    <SvgIcon name="delete" width="24px" height="24px" fill="#fff"></SvgIcon>
                </div>
            </div>
          <div class="post_pic" :style="bg(post)"></div>
          <div class="descr-wrap">
            <h4 class="title">{{post.title}}</h4>
            <div class="post-text">{{post.text}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import emptyImg from "@/assets/fotty.jpg"
import ConfirmPostRemove from '../basic/ConfirmPostRemove'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('posts')

export default {
  name: "PostsLists",
  data() {
    return {};
  },
  methods: {
    ...mapActions(['delete_post']),
    confirmModal: function (eventId, postId) {
      this.$modal.show(
        ConfirmPostRemove,
        {eventId, postId},
        {
          draggable: false,
          height: 'auto',
          width: 544
        }
      )
    },
    bg: function(post) {
      let url = post.files.length
        ? post.files[0].url
        : emptyImg;
      return `background:url(${url});`;
    },
    async onDelete (event_id, post_id) {
      await this.delete_post({event_id, post_id})
    }
  },

  computed: {
    ...mapGetters({
      event: "events/get_current",
      Posts: "posts/get_posts"
    })
  }
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 56px;
}
.post-cards-wrap {
  display: grid;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-columns: 1fr 1fr 1fr;
  .empty-card,
  .post-card {
    overflow: hidden;
    transition: box-shadow 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    &:hover {
      box-shadow: 0 16px 32px rgba(142, 142, 142, 0.16);
      cursor: pointer;
    }
      .picture_control {
          position: absolute;
          padding: 5px;
          justify-content: flex-end;
          align-items: flex-start;
          color: #fff;
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
          display: none;
          .remove-pic {
              width: 40px;
              height: 40px;
              flex: 0 0 40px;
              border-radius: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              background: #eb4b4b;
          }
      }
      &:hover {
          .picture_control {
              display: flex;
          }
      }
  }
  .empty-card {
    height: 360px;
    @include border();
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: $mainColor;
    div {
      margin-top: 32px;
    }
  }
  .post-card {
    position: relative;
    height: 360px;
    @include border($lightCalm);
    grid-template-rows: 176px auto;
    .post_pic {
      height: 176px;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center;
      &.empty {
        background-image: url("~@/assets/fotty.jpg");
      }
    }
    .descr-wrap {
      position: relative;
      padding: 16px 24px;

      height: 184px;
      overflow: hidden;
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 140px;
        bottom: 0;
        left: 0;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 83.98%
        );
      }
      .title {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
      }
      .post-text {
        font-size: 16px;
        line-height: 24px;
        color: #333;
      }

      align-self: flex-end;
      font-weight: normal;
      font-size: 14px;
      line-height: 28px;
      .descr-line {
        display: flex;
        justify-content: space-between;
        span {
          display: block;
          &:last-child {
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
